import { useVirtualizer } from '@tanstack/react-virtual';
import { memo } from 'react';

import { type WorkspaceListResponse } from '@air/types';

import {
  InternalBrowseWorkspaceModalListItem,
  type InternalBrowseWorkspaceModalListItemProps,
} from '~/components/v2/components/internal/modals/internal-browse-workspace-modal/InternalBrowseWorkspaceModalListItem';
import { useScrollElementContext } from '~/components/v2/components/shared/scroll/ScrollElementContextProvider';

export type InternalBrowseWorkspaceModalListProps = Pick<
  InternalBrowseWorkspaceModalListItemProps,
  'onSwitchWorkspace'
> & {
  workspaces: WorkspaceListResponse;
};

export const InternalBrowseWorkspaceModalList = memo(
  ({ onSwitchWorkspace, workspaces }: InternalBrowseWorkspaceModalListProps) => {
    const { scrollElement } = useScrollElementContext();
    const virtualizer = useVirtualizer({
      count: workspaces.length,
      estimateSize: () => 64,
      getScrollElement: () => scrollElement,
      overscan: 10,
    });

    const virtualItems = virtualizer.getVirtualItems();

    return (
      <div
        className="relative w-full"
        style={{
          height: virtualizer.getTotalSize(),
        }}
      >
        <div
          className="absolute top-0 left-0 w-full px-6"
          style={{ transform: `translateY(${virtualItems[0]?.start ?? 0}px)` }}
        >
          {virtualItems.map((virtualItem) => (
            <InternalBrowseWorkspaceModalListItem
              data-index={virtualItem.index}
              key={virtualItem.key}
              onSwitchWorkspace={onSwitchWorkspace}
              ref={virtualizer.measureElement}
              workspace={workspaces[virtualItem.index]}
            />
          ))}
        </div>
      </div>
    );
  },
);

InternalBrowseWorkspaceModalList.displayName = 'InternalBrowseWorkspaceModalList';
